<template>
    <div :id="id" class="row">
      <LmTextInput
        ref="inputFocus"
        :id="id + 'label'"
        class="col-12 col-md-4"
        v-model="component.componentProps.label"
        @input="onLabelChange($event)"
        :label="$t('title')"
        :placeholder="$t('title')"
        :help="$t('comp_title_help')"
      />
      <LmTextInput
        v-if="validateSuperUser"
        class="col-12 col-md-4"
        :id="id + 'nombre'"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        :label="$t('name')"
        :placeholder="$t('name')"
        :help="$t('comp_name_help')"
      />
      <LmTextInput
        class="col-12 col-md-4"
        :id="id + 'placeholder'"
        v-model="component.componentProps.placeholder"
        @input="$emit('input', component)"
        :label="$t('placeholder')"
        :placeholder="$t('placeholder')"
        :help="$t('comp_placeholder_help')"
      />
      <LmTextInput
        class="col-12 col-md-8"
        :id="id + 'help'"
        v-model="component.componentProps.help"
        @input="$emit('input', component)"
        :label="$t('helper_text_setter')"
        :placeholder="$t('helper_text_setter')"
        :help="$t('helper_text_setter_help')"
      />
      <LmSelect
        class="col-12 col-md-4"
        :id="id + 'optionsPath'"
        v-model="component.componentProps.optionsPath"
        :options="{
          content: [
            { text: $t('every'), value: '/users/all' },
            { text: $t('width_digital_signature'), value: '/users/all?signature=digital' }
          ]
        }"
        @input="$emit('input', component)"
        :label="$t('users')"
        :placeholder="$t('users')"
        :help="$t('signers_options_origin_setter_help')"
      />
      <hr class="w-100 mx-2">
      <div class="col-12">
        <h5>{{ $t('validations') }}</h5>
        <div class="row align-items-center">
          <LmCheckbox
            class="col-12 col-md-4"
            :labelSingle="$t('required')"
            v-model="validations.required"
            @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
          />
        </div>
      </div>
      <hr class="w-100 mx-2">
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :id="String(id)"
        :leftValueToCompareOptions="leftValueToCompareOptions"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
        @input="$emit('input', component)"
        />
      <LmConditionalByEditModeBuilderUi
        :component="component"
        @input="$emit('input', component)"
        />
      <!-- Componente para setear los permisos de usuario por campo del form -->
      <!-- <LmElementUserPermissionsUi
        :componentPermissions="component.componentPermissions"
      /> -->
    </div>
</template>

<script>
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
// TODO: Si todo va ok, pasar al mixin
// import LmElementUserPermissionsUi from './LmElementUserPermissionsUi'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      validations: {
        required: false,
        minLength: '',
        maxLength: '',
        sameAs: ''
      }
    }
  },
  // components: {
  //   LmElementUserPermissionsUi
  // },
  watch: {
    // componentPermissions: {
    //   handler (val) {
    //     if (val) {
    //       this.component.componentPermissions = val
    //       this.$emit('input', this.component)
    //     }
    //   },
    //   deep: true
    // },
    componentData () {
      this.component = this.componentData
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
